import { gql } from '@apollo/client'

export default gql`
  fragment CourseChapterPreview on CourseChapter {
    id
    title
    position
  }
`
